const types = {
  ADD_QUEUED_PATCH: "waitForId/ADD_QUEUED_PATCH",
  PATCH_WITH_SERVER_ID_START: "waitForId/PATCH_WITH_SERVER_ID_START",
  PATCH_WITH_SERVER_ID_COMMIT: "waitForId/PATCH_WITH_SERVER_ID_COMMIT",
  UNLISTEN: "waitForId/UNLISTEN",
  UNLISTEN_ALL: "waitForId/UNLISTEN_ALL",
};

export default types;
